import React from 'react'
import { Container } from 'react-bootstrap'


const Traffic = () => {
  return (
    <Container>
      <h1>Work In Progress</h1>
    </Container>
  )
}

export default Traffic